export enum HeaderThemeType {
  toggle = 'toggle',
  multioption = 'multioption',
}
